
webpack.register(
    'components/video-landing/live-video-right-rail/live-video-right-rail-channels/channel/channel',
    function() {
        return require('components/video-landing/live-video-right-rail/live-video-right-rail-channels/channel/channel');
    },
    false
);
webpack.register(
    'components/video-landing/live-video-right-rail/live-video-right-rail-channels/sponsor/sponsor',
    function() {
        return require('components/video-landing/live-video-right-rail/live-video-right-rail-channels/sponsor/sponsor');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/video-landing/live-video-right-rail/live-video-right-rail-channels/channel/channel'/>\r\n<can-import from='components/video-landing/live-video-right-rail/live-video-right-rail-channels/sponsor/sponsor'/>\r\n\r\n<div class=\"s-video-right-rail-channels {{#is activeTab 'channels'}}is-selected{{/is}}\">\r\n    {{#each cards}}\r\n        <right-rail-channel {(is-selected)}=\"isSelected\"\r\n                            {data}=\"this\"\r\n                            {active-view}=\"../activeView\"\r\n                            {(active-channels)}=\"../activeChannels\"\r\n                            {stream-off-messaging-config}=\"streamOffMessagingConfig\">\r\n        </right-rail-channel>\r\n    {{/each}}\r\n    \r\n</div>\r\n");